module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/system-level-setting/applicationManagement/applicationManagement.component.html
// module id = 1285
// module chunks = 10